import React, { useState, useEffect } from 'react';

const Popup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [popupData, setPopupData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dontShowToday, setDontShowToday] = useState(false);
  const [debugInfo, setDebugInfo] = useState('');

  // 오늘 날짜를 YYYY-MM-DD 형식으로 반환
  const getTodayString = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  // 로컬스토리지에서 오늘 하루 안보기 상태 확인
  const checkDontShowToday = () => {
    const savedDate = localStorage.getItem('popup_dont_show_date');
    const todayString = getTodayString();
    return savedDate === todayString;
  };

  // 팝업 데이터 가져오기
  const fetchPopupData = async () => {
    try {
      setDebugInfo('API 호출 시작...');
      const response = await fetch('/api/admin/popup/current');
      
      if (response.ok) {
        const data = await response.json();
        console.log('팝업 데이터:', data);
        setDebugInfo(`API 응답: ${JSON.stringify(data)}`);
        setPopupData(data);
        
        const isDontShow = checkDontShowToday();
        console.log('오늘 하루 안보기 상태:', isDontShow);
        setDebugInfo(prev => prev + ` | 오늘 안보기: ${isDontShow}`);
        
        // 팝업 데이터가 있고, 오늘 하루 안보기가 설정되지 않았다면 표시
        // pu_delete 필드가 없거나 0이면 활성화된 것으로 간주
        if (data && data.pu_file1_s && (data.pu_delete === undefined || data.pu_delete === 0) && !isDontShow) {
          setIsVisible(true);
          setDebugInfo(prev => prev + ' | 팝업 표시됨');
        } else {
          setDebugInfo(prev => prev + ` | 팝업 숨김 (pu_delete: ${data.pu_delete}, pu_file1_s: ${data.pu_file1_s})`);
        }
      } else {
        setDebugInfo(`API 오류: ${response.status}`);
      }
    } catch (error) {
      console.error('팝업 데이터를 가져오는 중 오류 발생:', error);
      setDebugInfo(`에러: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  // 팝업 닫기
  const closePopup = () => {
    if (dontShowToday) {
      // 오늘 하루 안보기 체크가 되어있다면 로컬스토리지에 저장
      localStorage.setItem('popup_dont_show_date', getTodayString());
    }
    setIsVisible(false);
  };

  // 컴포넌트 마운트 시 팝업 데이터 가져오기
  useEffect(() => {
    fetchPopupData();
  }, []);

  // 테스트용 팝업 강제 표시 버튼 (개발 중에만 사용)
  const showTestPopup = () => {
    setPopupData({
      pu_delete: 0,
      pu_file1_s: 'test-image.jpg',
      pu_link: null
    });
    setIsVisible(true);
  };

  // 디버그 정보 표시 (개발 중에만)
  console.log('팝업 상태:', { loading, isVisible, popupData, dontShowToday });

  // 로딩 중이거나 팝업이 보이지 않는 경우
  if (loading || !isVisible || !popupData) {
    return null;
    // return (
    //   <div style={{ 
    //     position: 'fixed', 
    //     top: '10px', 
    //     right: '10px', 
    //     background: 'rgba(0,0,0,0.8)', 
    //     color: 'white', 
    //     padding: '10px', 
    //     fontSize: '12px',
    //     zIndex: 10000,
    //     maxWidth: '300px'
    //   }}>
    //     <div>디버그 정보: {debugInfo}</div>
    //     <div>로딩: {loading ? 'true' : 'false'}</div>
    //     <div>표시: {isVisible ? 'true' : 'false'}</div>
    //     <div>데이터: {popupData ? '있음' : '없음'}</div>
    //     <button onClick={showTestPopup} style={{ marginTop: '5px' }}>
    //       테스트 팝업 표시
    //     </button>
    //     <button 
    //       onClick={() => localStorage.removeItem('popup_dont_show_date')} 
    //       style={{ marginTop: '5px', marginLeft: '5px' }}
    //     >
    //       로컬스토리지 초기화
    //     </button>
    //   </div>
    // );
  }

  return (
    <div 
      id="showimage1" 
      className="showimage"
    
    >
      <div 
        className="pop_inner" 
      
      >
        <div className="img_pop" >
          {popupData.pu_link ? (
            <a href='' target="_blank" rel="noopener noreferrer">
              <img 
                src={`/resources/upload/${popupData.pu_file1_s}`} 
                alt="popup_img"
               
              />
            </a>
          ) : (
            <a href='/sub6_1'>
 <img 
              src={`/resources/upload/${popupData.pu_file1_s}`} 
              alt="popup_img"
             
            />
            </a>
           
          )}
        </div>
        
        <div 
          className="check_pop" 
         
        >
          <label 
            htmlFor="pop01"
          
          >
            <input 
              type="checkbox" 
              name="pop01" 
              id="pop01" 
              checked={dontShowToday}
              onChange={(e) => setDontShowToday(e.target.checked)}
              title="오늘은 이창을 열지 않음 선택상자"
          
            />
            오늘 하루 그만 보기
          </label>
          
          <button 
            className="btn_close" 
            onClick={closePopup}
           
          >
            닫기 X
          </button>
        </div>
      </div>
    </div>
  );
};

export default Popup;